import { ChangeEvent, useContext, useEffect, useRef, useState } from "react";
import _, { debounce } from "lodash";
import { CircularProgress, TextField, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Autocomplete, AutocompleteRenderInputParams } from "@material-ui/lab";
import { ApiRoutes, FetchContext, HttpMethods } from "../contexts";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%'
    },
    icon: {
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(2)
    }
}));

export const SearchUser = (props) => {
    const classes = useStyles();
    const { fetchAuthorized } = useContext(FetchContext);

    const [open, setOpen] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    const abortControllerRef = useRef<AbortController | null>(null);

    const fetchUsers = async () => {
        const controller: AbortController = new AbortController();

        //aborting previous API call
        if (abortControllerRef.current)
            abortControllerRef.current.abort();

        abortControllerRef.current = controller;

        //try catch is needed to avoid breaking UI when debounce aborts previous API call
        try {
            const url = props.isAllUsers ?
                ApiRoutes.Graph.GetUsers({ userFullPartialName: inputValue }) :
                ApiRoutes.User.GetAOFOpeners({ userFullPartialName: inputValue });

            const response = await fetchAuthorized(
                url,
                {
                    method: HttpMethods.GET,
                    signal: controller.signal
                }
            );

            const data = await response.json();
            
            setOptions(data);
        }
        catch (error) {}
    };

    const debouncedFetchUsers = debounce(fetchUsers, 500);

    useEffect(() => {
        if (inputValue)
            debouncedFetchUsers();
        else
            setOptions([]);

        //nullifying debounce when component gets unmounted
        return () => {
            debouncedFetchUsers.cancel();
        };
    }, [inputValue]);

    useEffect(() => {
        setLoading(false);
    }, [options]);

    return (
        <>
            {
                props.label &&
                <Typography variant="overline">
                    {props.label}
                </Typography>
            }

            <Autocomplete
                {...props}
                style={{ marginTop: props.label ? '10px' : 0 }}
                open={open}
                onOpen={(): void => setOpen(true)}
                onClose={(): void => setOpen(false)}
                //getOptionSelected={(option, value) => option.mail === value.mail}
                options={options}
                loading={loading}
                onChange={(event, user) => props.onChange(user)}
                onInputChange={(event: ChangeEvent, newInputValue: string): void => {
                    setLoading(true);
                    setInputValue(newInputValue);
                }}
                renderInput={(params: AutocompleteRenderInputParams): JSX.Element =>
                    <TextField
                        {...params}
                        label="Search by name or email..."
                        variant="outlined"
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: <>
                                {
                                    loading ?
                                    <CircularProgress color="inherit" size={20} /> :
                                    <>
                                        <span
                                            onClick={() => {
                                                setInputValue(null);
                                                props.onChange(null);
                                            }}
                                        >
                                            {(params.InputProps.endAdornment as any).props.children[0]}
                                        </span>

                                        {(params.InputProps.endAdornment as any).props.children[1]}
                                    </>
                                }
                            </>
                        }}
                    />
                }
            />
        </>
    );
};